import Reflux from 'reflux';

const IndicesConfigurationActions = Reflux.createActions({
  loadRotationStrategies: { asyncResult: true },
  loadRetentionStrategies: { asyncResult: true },
});

export default IndicesConfigurationActions;



// WEBPACK FOOTER //
// ../graylog2-server/graylog2-web-interface/src/actions/indices/IndicesConfigurationActions.js